import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import theme from "../../styles/theme/theme";

const LoginRegisterModal = ({ show, onHide }) => {
  const navigate = useNavigate();

  const handleLogin = () => {
    onHide();
    navigate("/login");
  };

  const handleRegister = () => {
    onHide();
    navigate("/register");
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header
        style={{
          backgroundColor: theme.palette.background.paper,
          borderBottom: `2px solid ${theme.palette.secondary.main}`,
        }}
        closeButton
      >
        <Modal.Title
          style={{
            fontWeight: 600,
            fontSize: "1.25rem",
            color: theme.palette.text.primary,
          }}
        >
          Login Required
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ backgroundColor: theme.palette.background.paper }}>
        <p style={{ fontSize: "0.95rem", color: theme.palette.text.secondary }}>
          You need to login or register to explore product details.
        </p>
      </Modal.Body>

      <Modal.Footer
        style={{
          backgroundColor: theme.palette.background.paper,
          borderTop: `2px solid ${theme.palette.secondary.main}`,
          display: "flex",
          justifyContent: "space-between", // Cancel left, actions right
          alignItems: "center",
        }}
      >
        {/* Cancel on the left */}
        <Button
          onClick={onHide}
          style={{
            backgroundColor: "transparent",
            color: theme.palette.text.primary,
            border: `1px solid ${theme.palette.tertiary.main}`,
            borderRadius: 8,
            padding: "6px 14px",
            fontWeight: 500,
            fontSize: "0.95rem",
          }}
        >
          Cancel
        </Button>

        {/* Login & Register on the right */}
        <div style={{ display: "flex", gap: 12 }}>
          <Button
            onClick={handleLogin}
            style={{
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.background.paper,
              border: "none",
              borderRadius: 8,
              padding: "6px 14px",
              fontWeight: 500,
              fontSize: "0.95rem",
            }}
          >
            Login
          </Button>

          <Button
            onClick={handleRegister}
            style={{
              backgroundColor: theme.palette.dark.main,
              color: theme.palette.dark.contrastText,
              border: "none",
              borderRadius: 8,
              padding: "6px 14px",
              fontWeight: 500,
              fontSize: "0.95rem",
            }}
          >
            Register
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default LoginRegisterModal;
